import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

// @material-ui
import { Grid, Typography } from '@material-ui/core'

// core
import { useGlobal } from '_core/hooks/useGlobal'
import { withLang } from '_core/hocs/withLang'
import { withCatch } from '_core/hocs/withCatch'
import { CurrencyChart } from '_core/components/CurrencyChart'
import { CurrencyConverter } from '_core/components/CurrencyConverter'
import { State } from '_core/components/State'
import { Title } from '_core/components/Title'

// style
import { useCurrencyRatesStyle } from './currencyRatesStyle'

export const RawCurrencyRates = props => {
  const { initialSource, updateTime, langInfo, getLangString: l } = props
  const classes = useCurrencyRatesStyle()

  const {
    request: { queue },
    config: { API_METHOD },
  } = useGlobal()

  const [source, setSource] = useState()
  const [nodeKey, setNodeKey] = useState(0)

  useEffect(() => {
    setNodeKey(nk => nk + 1)
  }, [langInfo])

  useEffect(() => {
    const timer = setInterval(() => setNodeKey(nk => nk + 1), updateTime)

    return () => {
      clearInterval(timer)
    }
  }, [])

  const getCurrencies = () =>
    queue(API_METHOD.CURRENCY, null, RawCurrencyRates.displayName)

  const getRates = () =>
    queue(
      API_METHOD.MONEY_CURRENCY_CALCULATOR,
      { source: source != null ? source : initialSource },
      RawCurrencyRates.displayName
    )

  return (
    <State
      key={nodeKey}
      getProps={{
        rates: getRates,
        currencies: getCurrencies,
      }}
      render={({ rates, currencies }) => {
        if (currencies.list.length === 0 || rates.list.length === 0) {
          return (
            <Typography align="center" variant="h6" color="textSecondary">
              {l('r.nichego.ne.najdeno')}
            </Typography>
          )
        }

        return (
          <div className={classes.root}>
            <Title icon="monetization_on">{l('r._.currencyrates.title')}</Title>

            <Grid container={true}>
              <Grid item={true} xs={12} lg={4} className={classes.column}>
                <CurrencyConverter
                  source={source}
                  rates={rates.list}
                  currencies={currencies.list}
                  time={rates.time.value}
                  setSource={setSource}
                />
              </Grid>

              <Grid item={true} xs={12} lg={8} className={classes.column}>
                <CurrencyChart
                  rates={rates.list}
                  source={source}
                  currencies={currencies.list}
                />
              </Grid>
            </Grid>
          </div>
        )
      }}
    />
  )
}

RawCurrencyRates.displayName = 'RawCurrencyRates'

RawCurrencyRates.defaultProps = {
  // updateTime: 5000,
  updateTime: 15 * 60 * 1000,
  initialSource: 'user',
}

RawCurrencyRates.propTypes = {
  // self props
  initialSource: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  // `withLang` HOC props
  langInfo: PropTypes.object,
  langStrings: PropTypes.object,
  getLangObject: PropTypes.func,
  getFirstLangString: PropTypes.func,
  getLangStringSet: PropTypes.func,
  getLangString: PropTypes.func.isRequired,
}

export const CurrencyRates = withCatch(withLang(RawCurrencyRates))
